module.exports = __webpack_public_path__ + "img/Image1.371e544c.jpg";